export enum Civility {
  Mr = 1,
  Mrs = 2
}
